
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();

export const deleteAction = async (actionId) => {

    if(Number(actionId) <=0){
      throw new Error(`Error: actionId is required.`);
    }

   
  
    const response = await authenticatedFetch(`${config.API_BASE_URL}/actions/${actionId}`, {
        method: 'DELETE',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        }
      });

    
      
      if (response.ok) {
        const responseData = await response.json();
        return responseData; 
      } else {
        throw new Error(`Error deleting action`);
      }
  
  };